import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { getAuthHttpHeaders } from "../auth";
import Dimensions from "react-dimensions";
import {
  VictoryLine,
  VictoryChart,
  VictoryScatter,
  VictoryZoomContainer,
  VictoryTheme,
  VictoryAxis,
  VictoryLabel,
  VictoryPortal,
} from "victory";
import { instantFromApi } from "../utils/dateTime";
import { Message, Button } from "semantic-ui-react";
import PercentagePieChart from "../charts/PercentagePieChart";
import { getBotConfig, getBotState } from "../utils/botUtils";
import MonthProfitChart from "../charts/MonthProfitChart";

@inject("store")
@observer
class BotStats extends Component {
  state = {
    loading: false,
    data: null,
  };

  componentDidMount() {
    this.load(this.props.botInstance.id);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.botInstance.id !== this.props.botInstance.id) {
      this.load(newProps.botInstance.id);
    }
  }

  async load(botId) {
    this.setState({ loading: true });

    try {
      let axiosRequest = axios.create({
        baseURL: "api",
        timeout: 30 * 1000,
        headers: {
          Accept: "application/json",
          ...getAuthHttpHeaders(),
        },
      });

      let response = await axiosRequest.get("chart/profit/bot/" + botId);
      this.setState({ data: response.data });
    } catch (e) {
      this.setState({ data: null });
    } finally {
      this.setState({ loading: false });
    }
  }

  render() {
    const {
      store: {
        chartsDisplayed: { closedProfitCumulative, closedProfit },
        toggleChartDisplayed,
      },
      botInstance,
    } = this.props;

    const state = getBotState(botInstance);
    const config = getBotConfig(botInstance);

    return (
      <div>
        <Button
          content="Cumulative Closed Profit"
          toggle
          active={closedProfitCumulative}
          onClick={() => toggleChartDisplayed("closedProfitCumulative")}
        />
        <Button
          content="Closed Trade Profit"
          toggle
          active={closedProfit}
          onClick={() => toggleChartDisplayed("closedProfit")}
        />

        <Button
          content="Refresh"
          icon="refresh"
          onClick={() => this.load(botInstance.id)}
          loading={this.state.loading}
        />

        {!this.state.loading && !this.state.data && <Message negative>No data.</Message>}

        {this.state.data &&
          (closedProfitCumulative || closedProfit) && (
            <VictoryChart
              scale={{ x: "time", y: "linear" }}
              width={this.props.containerWidth}
              height={400}
              domainPadding={10}
              theme={VictoryTheme.material}
              key={botInstance.id + ":" + closedProfitCumulative + "," + closedProfit} // fix y-axis with VictoryZoomContainer when toggling charts
              containerComponent={<VictoryZoomContainer zoomDimension="x" />}
            >
              <VictoryAxis />
              <VictoryAxis
                dependentAxis
                tickLabelComponent={
                  <VictoryPortal>
                    <VictoryLabel
                      text={d => {
                        const percents = (d / config.tradeTotal * 100).toFixed(1) + "%";
                        return d + "\n" + percents;
                      }}
                    />
                  </VictoryPortal>
                }
              />

              {closedProfitCumulative && (
                <VictoryLine
                  data={this.state.data}
                  x={d => instantFromApi(d.date).toEpochMilli()}
                  y="cumulativeProfit"
                  interpolation="stepAfter"
                />
              )}

              {closedProfit && (
                <VictoryScatter
                  data={this.state.data}
                  x={d => instantFromApi(d.date).toEpochMilli()}
                  y="profit"
                  style={{
                    data: {
                      fill: d => (d.profit > 0 ? "green" : "red"),
                      fillOpacity: 0.7,
                    },
                  }}
                />
              )}
            </VictoryChart>
          )}
        <MonthProfitChart trades={this.state.data} tradeTotal={config.tradeTotal} width={this.props.containerWidth} />
        <div>
          {(state.stats &&
            state.stats.openRealized && (
              <PercentagePieChart
                key={botInstance.id + "perc1"}
                style={{ width: "300px", display: "inline-block" }}
                value={state.stats.openRealized / state.stats.openAttempts * 100}
                label="Avg. opened trades"
              />
            )) ||
            ""}
          {(state.stats &&
            state.stats.openRealized && (
              <PercentagePieChart
                key={botInstance.id + "perc2"}
                style={{ width: "300px", display: "inline-block" }}
                value={state.stats.avgRealizedAmountPct}
                label="Avg. realized amount"
              />
            )) ||
            ""}
        </div>
      </div>
    );
  }
}

export default Dimensions()(BotStats);



// WEBPACK FOOTER //
// ./src/bot/BotStats.js